// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"5acd488e","513":"b9d5f3f4","703":"e87620f6"}[chunkId] + ".chunk.js";
};